<script setup>

const props = defineProps({
  options: Object,
  course: Object
})

const {getAllTopLevelDiscounts} = useTopLevelData()
const {data: topLevelDiscounts} = await getAllTopLevelDiscounts();

const config = useRuntimeConfig()
const {search} = useLocationData()

const { $offcanvas } = useNuxtApp();
const { version } = useZigZag()
const { data, refresh } = await version(config.public.zigzagUrl)

const time = data.value ? data.value.t : 0;
const sha = data.value ? data.value.sha : 'versionnotfound';

const url = `${config.public.zigzagUrl}/app/layout/shell.html?sha=${sha}&t=${time}`;

const bsOffcanvas = ref();
const visible = ref(true)
const spaIsVisible = ref(true)
const offcanvasStatus = ref(false)

const openDrawer = (prod) => {
  location.href =  `#/reg-flow/tutoring?prodid=${prod.prodId}&subscription=${fields.enableSubscription}`;
  visible.value = false;
  spaIsVisible.value = true;
  offcanvasStatus.value = true;
  document.body.style.overflow = 'hidden';
}

const closeOffcanvas = () => {
  offcanvasStatus.value = false;
  document.body.style.overflow = 'visible';
  visible.value = true;
  spaIsVisible.value = true;
}

// For mobile use only
const openOffcanvas = () => {
  visible.value = true;  
  spaIsVisible.value = false; 
  offcanvasStatus.value = true;
  document.body.style.overflow = 'hidden';
}


onMounted(() => {
  bsOffcanvas.value = document.getElementById('miniavcDrawerSlider');

  window.addEventListener('hashchange', function () {
    // Checking if the URL hash changed and hiding the drawer in case the prod Id is not present
    if (!window.location.hash.includes('prodid')) {
      closeOffcanvas();
    }
  });

})


const fields = props.options;
// Cheking for any custom field from the course collection
if (props.course.floatingBlock !== null) {
  if (props.course.floatingBlock.image && props.course.floatingBlock.image.data ) {    
    fields.image = props.course.floatingBlock.image.data.attributes;
  }
  if (props.course.floatingBlock.blockContent) {
    fields.blockContent = props.course.floatingBlock.blockContent;
  }
  if (props.course.floatingBlock.searchButton) {
    fields.buttonText = props.course.floatingBlock.searchButton.buttonText;
  }
  if (props.course.floatingBlock.mobileButtonText) {
    fields.mobileButtonText = props.course.floatingBlock.mobileButtonText;
  }  
  if (props.course.floatingBlock.subtext) {
    fields.subtext = props.course.floatingBlock.subtext;
  }
  if (props.course.floatingBlock.enableSubscription !== null && props.course.floatingBlock.enableSubscription !== 'undefined') {    
    fields.enableSubscription = props.course.floatingBlock.enableSubscription;
  }
}

const discountByProductId = (prodId) => {
  const discount = topLevelDiscounts.value.data.find((discount) => {
    return discount.productIDs.includes(prodId) && discount.discountTypeID == 49025
  })
  
  return discount ? discount : {discountID: 0, value: 0, discountValueTypeID: 0}
}

const baseAlaCartProduct = props.course.variants.find(product => product.quantity == 1);
const baseAlaCartPrice = baseAlaCartProduct ? baseAlaCartProduct.price : props.course.variants[0].price;

const subscriptionSaveCalculation = (subUnitPrice) => {
  const savePercentageRaw = Math.round(baseAlaCartPrice - subUnitPrice);
  return Math.round( (savePercentageRaw / ((baseAlaCartPrice + subUnitPrice) / 2)) * 100 ) ;
}

const pricingCards = props.course.variants.map(product => {
  const productDiscount = discountByProductId(product.pulseId);

  return {
    discountId: productDiscount.discountID,
    productId: product.pulseId,
    unit: "Lesson",
    totalPrice: product.price,
    quantity: product.quantity,
    unitPrice: product.price / product.quantity,
    discountValue: productDiscount.value,
    discountValueType: productDiscount.discountValueTypeID,
    isMostPopular: product.isMostPopular,
    baseAlaCartPrice: baseAlaCartPrice,
    isVisible: product.visibilityTypeId != 330003 && product.visibilityTypeId != 330004,
    subcriptionTotalPrice: product.price - productDiscount?.value,
    subscriptionUnitPrice: (product.price - productDiscount?.value) / product.quantity,
    subscriptionSavePercentage: subscriptionSaveCalculation((product.price - productDiscount?.value) / product.quantity)
  }
});

const popular = props.course.variants.find(product => product.isMostPopular);


const selectedPackage = ref(popular ? popular.pulseId : 0)
const handleSelection = (prodId) => {
  selectedPackage.value = prodId
}

const mobileClass = computed(() => {
  return {
    "d-block": visible.value,
    "d-md-none": visible.value,
    "d-none": !visible.value
  }
})

const spaSection = computed(() => {
  return {
    "d-block": spaIsVisible.value,    
    "d-none": !spaIsVisible.value
  }
})

</script>

<template>
  
  <CourseBaseFloatingBlock>
    <template v-slot:block-body>
      <CourseSelectPackage :pricingCards="pricingCards" :popular="selectedPackage" :fields="fields" @click="openDrawer" />
    </template>
    <template v-slot:block-subtext>
      <div class="text-center mt-3" v-html="fields.subtext" v-if="fields.subtext"></div>
    </template>
    <template v-slot:mobile-body>
      <button :class="`btn btn-primary w-100`" @click="openOffcanvas">{{ fields.mobileButtonText }}</button>
    </template>
  </CourseBaseFloatingBlock> 

  <div class="offcanvas offcanvas-end www-drawer w-100" :class="{'show': offcanvasStatus}" id="miniavcDrawerSlider" tabindex="-1"  aria-labelledby="offcanvasLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasLabel"></h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" @click="closeOffcanvas"></button>
    </div>
    <div class="offcanvas-body">
      <div class="package-container " :class="mobileClass">
        <CourseSelectPackage :pricingCards="pricingCards" :popular="selectedPackage" :fields="fields" :mobile="true" @click="openDrawer"  />
      </div>
      <div id="www-spa-container" class="www-pulseapp mini-avc" :class="spaSection" data-page="/reg-flow/tutoring">
        <div class="pulseapp">
          <AngularSpinner />
          <div class="shell-container" :ng-include="`'${url}'`">
              <div class="box-wrapper">
                <span class="spinner"></span>
                <strong>Loading...</strong>
              </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
  <div class="offcanvas-backdrop fade" :class="{'show': offcanvasStatus, 'd-none': !offcanvasStatus}"></div>
  
</template>

<style lang="scss" scoped>


.offcanvas {
  transition: all 0.8s ease-in-out;
  box-shadow: -0.5rem 0 1rem rgba(0, 0, 0, 0.5);

}

.www-drawer {
  max-width: 650px;
  // Temporary styles to avoid conflicts with ZigZag  
  .www-pulseapp  {
    .btn {
      border: none;
      text-decoration: none;
      .text-nowrap {
        font-weight: 400;
      }
      .btn-pill-lg {
        padding: 0.8rem 2rem 0.8rem 2rem;
        font-size: 0.75rem;
      }
    }
    .btn-close {
      width: auto;
      background: none;
      color: inherit;
      
    }  
  }
  
}




</style>